import styled, { css } from 'styled-components';
import { focusRing, noSelect } from '../../../../../../styles/mixins';
import { LI_HEIGHT } from '../../../../../../styles/constants';

export const LiContainer = styled.li<{ hasAddLabel?: boolean; isListBox: boolean }>`
  position: relative;
  line-height: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-height: ${LI_HEIGHT};
  ${noSelect};

  ${({ isListBox }) =>
    isListBox
      ? css`
          display: block;
          padding: 0px 16px;
          cursor: pointer;
          span {
            font-weight: bold;
          }
          &[role='option']:hover,
          &[role='option'].focused {
            background-color: #f4f4f8;
          }
          &.selected {
            //margin: 0 auto;
            border-radius: 3px;
          }
          &.whith-label {
            height: auto;
          }
          &[aria-selected='true'] {
            font-weight: 700;
          }
          .listbox-label {
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
          }
          .add-label {
            position: relative;
            font-size: ${({ theme }) => theme.kallisto.font.size['175']};

            white-space: normal;
            color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
            line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
          }
        `
      : css`
          display: flex;
          cursor: pointer;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;

          /* checkbox icon only (direct child) — the option label may contain its own svgs, e.g. Rating stars */
          > svg {
            margin-right: 16px;
            fill: #fff;
            min-width: 20px;
            rect {
              fill: #fff;
              stroke-width: 1;
              stroke: ${({ theme }) => theme.kallisto.color.common.black[200]};
            }
          }
          &[role='option']:hover,
          &[role='option']:focus {
            > svg rect {
              @media (hover: hover) {
                stroke: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
              }
            }
          }

          &[role='option']:focus-visible {
            outline: none;
            outline-offset: 0;
            box-shadow: none;
            overflow: visible;

            > svg {
              border-radius: 2px;
              overflow: visible;
              ${focusRing}
            }
          }

          .add-label {
            position: relative;
            font-size: ${({ theme }) => theme.kallisto.font.size['175']};
            white-space: normal;
            color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
            line-height: 18px;
            margin-left: 8px;
          }
        `}

  &.disabled {
    opacity: 0.3;
    cursor: default;
    &[role='option']:hover,
    &[role='option']:focus {
      > svg rect {
        @media (hover: hover) {
          stroke: ${({ theme }) => theme.kallisto.color.common.black[200]};
        }
      }
    }
  }
  &.whith-label {
    min-height: ${LI_HEIGHT};
  }
  &.two-columns {
    min-height: ${LI_HEIGHT};
    width: calc(50% - 16px);
  }
  &.icon-on-the-right {
    > svg {
      margin-left: 8px;
      margin-right: 0;
    }
    .add-label {
      margin-left: auto;
    }
  }

  ${({ hasAddLabel }) =>
    !hasAddLabel
      ? css`
          &.icon-on-the-right {
            > svg {
              margin-left: auto;
            }
          }
        `
      : css`
          &.two-columns {
            .add-label {
              margin-left: 16px;
              height: 24px;
              line-height: 24px;
            }
          }
        `}

  &.selected {
    //margin: 0 auto;
    border-radius: 3px;
    > svg {
      rect {
        stroke: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
        fill: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
      }
    }
  }
`;
